<script>
import TemplateList from "@/components/widgets/du-service-template.vue";
import ServiceSubscribers from '@/components/widgets/service-subscribers.vue'
import ServiceMap from '@/components/widgets/service-map.vue'
import ServiceUnpaid from '@/components/widgets/service-unpaid.vue'
export default {
    name: "ServiceList",
    components: {
        TemplateList,
        ServiceSubscribers,
        ServiceMap,
        ServiceUnpaid
    },
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        filter: {
            type: String,
            default: null,
        },
        canEdit: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        filtered() {
            let data = this.list;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data;
        },
    },
    methods: {
        showTemplates(item){
            this.$emit('show-templates', item)
        },
        async selectMenu(item, index){
            this.$emit('select-menu', {item, index})
        },
        addTemplate(item){
            this.$emit('add-template', item)
        },
        editTemplate(row, parent){
            this.$emit('edit-template', {row, parent})
        },
        deleteTemplate(row, parent){
            this.$emit('delete-template', {row, parent})
        },
        addFees(duServices, service){
            this.$emit('add-fees', {duServices, service})
        },
        addSubscriber(service){
            this.$emit('add-subscriber', service)
        },
        updateSubscriber(service, data){
            this.$emit('update-subscriber', {service, data})
        },
        removeSubscriber(service, data){
            this.$emit('remove-subscriber', {service, data})
        },
        subscriberReading(service, item){
            this.$emit('subscriber-reading', {service, item})
        },
        addServiceMap(placeholder, parent){
            this.$emit('add-service-map', {placeholder, parent})
        },
        editServiceMap(item, parent){
            this.$emit('edit-service-map', {item, parent})
        },
        deleteServiceMap(item, parent){
            this.$emit('delete-service-map', {item, parent})
        },
        editService(item){
            this.$emit('edit-service', item)
        },
        deleteService(item){
            this.$emit('delete-service', item)
        },
        targetTemplate(id, data){
            this.$refs[`tempList-${id}`][0].selectTemplate(data);
        },
        addFeesToTemplate(id, data){
            this.$refs[`tempList-${id}`][0].addFeesToTemplate(data);
        },
        calculateGridSize(id){
            this.$refs[`map-${id}`][0].calculateGridSize();
        },
        getUnpaid(dates, data){
            this.$emit('get-unpaid', {dates, data})
        },
        getUnpaidSummary(data){
            this.$emit('get-unpaid-summary', data)
        },
        generateReadings(data){
            this.$emit('generate-readings', data)
        },
        printReading(data){
            this.$emit('generate-readings', [data])
        },
    }
}
</script>
<template>
    <div>
        <template v-for="(x, xIndex) in filtered">
            <b-card
                :key="x.id"
                no-body
                class="mb-1 shadow-none"
                :style="{'zIndex': filtered.length - xIndex}"
            >
                <b-card-header
                    header-tag="header"
                    role="tab"
                    class="border"
                >
                    <div
                        class="
                            d-flex
                            justify-content-between
                            align-items-center
                        "
                    >
                        <div class="d-flex align-items-start">
                            <div style="width: 5px;height:5px;" class="bg-warning bg-gradient text-center me-2 mt-1"></div>
                            <div class="text-muted">
                                <div class="d-flex hover-toggle">
                                    <h5 class="mb-0 line-height-1 hover-underline cursor-pointer me-1 " @click="showTemplates(x)">
                                        {{ x.serviceName }}
                                    </h5>
                                    <div class="hover-content-inline" v-if="canEdit">
                                        <i class="bx bx-edit font-size-14 cursor-pointer text-success" @click="editService(x)"></i>
                                        <i class="bx bx-trash font-size-14 cursor-pointer text-danger" @click="deleteService(x)"></i>
                                    </div>
                                </div>
                                <small class="badge bg-success bg-gradient text-white rounded px-2">{{x.fundSource.sourceName}}</small>
                            </div>
                        </div>
                        <div>
                            <a href="javascript:void(0)" class="btn btn-outline-primary" @click="showTemplates(x)">
                                {{x.rotateChevy ? 'Hide' : 'Show'}} More Options
                            </a>
                        </div>
                    </div>
                </b-card-header>
                <b-collapse
                    :visible="x.rotateChevy"
                    :accordion="`prexc-${x.id}`"
                    role="tabpanel"
                >
                    <b-card-body class="border">
                        <div class="d-flex gap-1 mb-2 pb-2 border-bottom">
                            <a 
                                href="javascript:void(0)"
                                class="temp-options d-flex align-items-center justify-content-center gap-1" 
                                :class="{'active': x.menuSelection == 0}" 
                                @click="selectMenu(x, 0)"
                            >
                                <i class="bx bx-money font-size-18"></i> <span>Fees</span>
                            </a>
                            <a 
                                href="javascript:void(0)" 
                                class="temp-options d-flex align-items-center justify-content-center gap-1" 
                                :class="{'active': x.menuSelection == 1}"
                                @click="selectMenu(x, 1)"
                            >
                                <i class="bx bx-badge-check font-size-18"></i> <span>Subscribers</span>
                            </a>
                            <a 
                                href="javascript:void(0)" 
                                class="temp-options d-flex align-items-center justify-content-center gap-1" 
                                :class="{'active': x.menuSelection == 2}" 
                                @click="selectMenu(x, 2)"
                            >
                                <i class="bx bx-map font-size-18"></i> <span>Map</span>
                            </a>
                            <a 
                                href="javascript:void(0)" 
                                class="temp-options d-flex align-items-center justify-content-center gap-1 px-4" 
                                :class="{'active': x.menuSelection == 3}" 
                                @click="selectMenu(x, 3)"
                                v-if="x.useMeterReading"
                            >
                                <i class="bx bx-notification-off font-size-18"></i> <span>Unpaid Services</span>
                            </a>
                        </div>
                        <TemplateList
                            v-if="x.menuSelection == 0"
                            :ref="`tempList-${x.id}`"
                            :templates="x.templates"
                            :useMeterReading="x.useMeterReading"
                            :loading="x.loading"
                            @add-template="addTemplate(x)"
                            @edit-template="editTemplate($event, x)"
                            @delete-template="deleteTemplate($event, x)"
                            @add-fees="addFees($event, x)"
                            @add-subscriber="addSubscriber(x)"
                        />
                        <ServiceSubscribers 
                            :loading="x.subscriberLoading"
                            :subscribers="x.subscribers"
                            :service="x"
                            :withReading="x.useMeterReading"
                            @addSubscriber="addSubscriber(x)"
                            @editSubscriber="updateSubscriber(x, $event)"
                            @removeSubscriber="removeSubscriber(x, $event)"
                            @subscriberReading="subscriberReading(x, $event)"
                            @printReading="printReading"
                            v-if="x.menuSelection == 1"
                        />
                        <ServiceMap 
                            :ref="`map-${x.id}`"
                            :loading="x.mapLoading"
                            :items="x.maps"
                            v-if="x.menuSelection == 2"
                            @add-service-map="addServiceMap($event, x)"
                            @edit-service-map="editServiceMap($event, x)"
                            @delete-service-map="deleteServiceMap($event, x)"
                            @add-subscriber="addSubscriber(x, $event)"
                        />
                        <ServiceUnpaid 
                            :ref="`unpaid-${x.id}`"
                            v-if="x.menuSelection == 3"
                            :loading="x.unpaidLoading"
                            :items="x.unpaid"
                            :service="x"
                            @load-data="getUnpaid($event, x)"
                            @load-summary="getUnpaidSummary(x)"
                            @generate-readings="generateReadings($event)"
                            @printReading="printReading"
                        />
                    </b-card-body>
                </b-collapse>
            </b-card>
        </template>
    </div>
</template>